import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import ReduxThunk from 'redux-thunk';
import api from 'lib/evvntApi';
import reducers, { initialStates } from '../reducers';
import { getInitialFormValues } from './../reducers/formLocalStorageReducer';

const prepareRailsProps = (railsProps) => {
  if (railsProps === {}) { return initialStates; }
  return {
    checkoutData: initialStates.checkoutData.merge(railsProps.checkout_data),
    currentUser: initialStates.currentUser.merge({ data: railsProps.current_user }),
    urlTypes: railsProps.url_types,
    currencies: railsProps.currencies,
    categories: railsProps.categories,
    pricingTiers: railsProps.pricing_tiers,
    subscriptionTiers: railsProps.subscription_tiers,
    timeZones: railsProps.time_zones,
    config: railsProps.config,
    form: {
      eventSubmission: getInitialFormValues(railsProps.form_data, railsProps.config),
    }
  };
};

const configureStore = (railsProps = {}) => (
  createStore(
    combineReducers(reducers),
    prepareRailsProps(railsProps),
    compose(
      applyMiddleware(ReduxThunk.withExtraArgument(api)),
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    )
  )
);

export default configureStore;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/store/eventSubmissionStore.js